function toggleMenu23() {
    let menu = document.getElementById('header-23-menu');
    menu && menu.classList.toggle('header-23_open');
    menu && menu.classList.toggle('d-none');
    let burger = document.getElementById('header-23-burger');
    if (burger && burger.getAttribute('src') === '/img/header/burger.svg') {
        burger.setAttribute('src', '/img/header/cross.svg')
        this.document.body.classList.add('header-is-open');
    } else if (burger) {
        burger.setAttribute('src', '/img/header/burger.svg')
        this.document.body.classList.remove('header-is-open');
    }
}

function toggleNav23(name) {
    let list = ['services', 'solutions', 'technologies'];
    list.forEach(item => {
        let link = document.getElementById('header-23-' + item + '-link');
        if (link && item !== name && link.classList.contains('header-23_link-open')) {
            link.classList.remove('header-23_link-open');
        } else if (link && item === name) {
            link.classList.toggle('header-23_link-open');
        }
        let nav = document.getElementById('header-23-' + item + '-nav');
        if (nav && item !== name && nav.classList.contains('header-23_nav-open')) {
            nav.classList.remove('header-23_nav-open');
        } else if (nav && item === name) {
            nav.classList.toggle('header-23_nav-open');
        }
    });
}

function changeActiveService23(serviceId) {
    const serviceButtons = document.querySelectorAll('.home-23-services_box');
    serviceButtons.forEach(serviceButton => {
        serviceButton.classList.remove('active');
    });

    const serviceContents = document.querySelectorAll('.home-23-services_content');
    serviceContents.forEach(serviceContent => {
        serviceContent.classList.remove('active');
    });

    const selectedServiceButton = document.querySelector(`.service-${serviceId}`);
    selectedServiceButton.classList.add('active');

    const selectedServiceContents = document.querySelectorAll(`.service-content-${serviceId}`);
    selectedServiceContents.forEach(selectedServiceContent => {
        selectedServiceContent.classList.add('active');
    });
}

window.addEventListener('DOMContentLoaded', () => {
    const serviceButtons23 = document.querySelectorAll('.home-23-services_box');
    serviceButtons23.forEach(serviceButton => {
        serviceButton.addEventListener('click', () => {
            changeActiveService23(serviceButton.dataset.serviceId);
        });
    });

    const path = location.pathname;
    document.querySelectorAll('.home-23-link').forEach(item => {
        const target = item.getAttribute('data-target');
        if (path === target) {
            item.classList.add('active');
        } else {
            item.classList.remove('active');
        }
    });

    const burger23 = document.querySelector('#header-23-burger');
    if (burger23) {
        burger23.addEventListener('click', () => {
            toggleMenu23();
        });
    }

    const servicesLink23 = document.querySelector('#header-23-services-link');
    if (servicesLink23) {
        servicesLink23.addEventListener('click', () => {
            toggleNav23('services');
        });
    }

    const solutionsLink23 = document.querySelector('#header-23-solutions-link');
    if (solutionsLink23) {
        solutionsLink23.addEventListener('click', () => {
            toggleNav23('solutions');
        });
    }

    const technologiesLink23 = document.querySelector('#header-23-technologies-link');
    if (technologiesLink23) {
        technologiesLink23.addEventListener('click', () => {
            toggleNav23('technologies');
        });
    }
});
